"use client"

import { useBottomSheetStore } from "./store/useBottomSheetStore"
import BaseBottomSheetPortal from "./BaseBottomSheetPortal"

export default function BottomSheetPortal() {
  const store = useBottomSheetStore()

  return <BaseBottomSheetPortal store={store} zIndex="z-9999" />
}
